module.exports = __webpack_public_path__ + "static/media/signature.3442c6a2.svg";